
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cart.cjs.production.min.js')
} else {
  module.exports = require('./cart.cjs.development.js')
}
